export const isLoggedUser = (id) => id === localStorage.getItem('userId') || id === localStorage.getItem('userSlug');
